import script from "./progress.vue?vue&type=script&setup=true&lang=js"
export * from "./progress.vue?vue&type=script&setup=true&lang=js"

import "./progress.vue?vue&type=style&index=0&id=767bfee6&lang=less"

const __exports__ = script;

export default __exports__